import { KontoausgleichMobile } from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/KontoausgleichMobile';

export function FeiertagskontoContentMobile() {
  return <KontoausgleichMobile />;
}
